import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return null;
  }

  return (
    <nav className="border-b border-gray-200 bg-white">
      <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="text-xl font-semibold text-gray-900 tracking-tight hover:opacity-70">
          Moss Group
        </Link>
        <div className="flex items-center gap-8">
          <Link 
            to="/" 
            className="text-sm text-gray-600 hover:text-gray-900 font-medium"
          >
            Blog
          </Link>
          <Link 
            to="/about" 
            className="text-sm text-gray-600 hover:text-gray-900 font-medium"
          >
            About
          </Link>
          <a 
            href="https://mossgroup.org" 
            className="text-sm text-gray-600 hover:text-gray-900 font-medium"
            target="_blank"
            rel="noopener noreferrer"
          >
            Back to Moss Group
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
